/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type {
  DataResponseListClaimTypeInfo,
  DataResponseListClaimTypeRead,
  ErrorResponse,
  GetParticipantClaimTypesClaimTypesMeGetParams,
  HTTPValidationError,
} from "../../model";
import type { ErrorType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get Claim Types
 */
export const getClaimTypesClaimTypesGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseListClaimTypeRead>(
    { url: `/claim-types`, method: "GET", signal },
    options
  );
};

export const getGetClaimTypesClaimTypesGetQueryKey = () => {
  return [`/claim-types`] as const;
};

export const getGetClaimTypesClaimTypesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClaimTypesClaimTypesGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>
  > = ({ signal }) => getClaimTypesClaimTypesGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClaimTypesClaimTypesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>
>;
export type GetClaimTypesClaimTypesGetQueryError = ErrorType<unknown>;

export function useGetClaimTypesClaimTypesGet<
  TData = Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>,
          TError,
          Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClaimTypesClaimTypesGet<
  TData = Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>,
          TError,
          Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClaimTypesClaimTypesGet<
  TData = Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Claim Types
 */

export function useGetClaimTypesClaimTypesGet<
  TData = Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClaimTypesClaimTypesGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClaimTypesClaimTypesGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get the claim types and receipt categories enabled for a participant's
 * Study Country.
 *
 * A participant gets their own. A User with Claims Create names the
 * participant with ``participant_id``.
 * @summary Get Participant Claim Types
 */
export const getParticipantClaimTypesClaimTypesMeGet = (
  params?: GetParticipantClaimTypesClaimTypesMeGetParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseListClaimTypeInfo>(
    { url: `/claim-types/me`, method: "GET", params, signal },
    options
  );
};

export const getGetParticipantClaimTypesClaimTypesMeGetQueryKey = (
  params?: GetParticipantClaimTypesClaimTypesMeGetParams
) => {
  return [`/claim-types/me`, ...(params ? [params] : [])] as const;
};

export const getGetParticipantClaimTypesClaimTypesMeGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetParticipantClaimTypesClaimTypesMeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetParticipantClaimTypesClaimTypesMeGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>
  > = ({ signal }) =>
    getParticipantClaimTypesClaimTypesMeGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetParticipantClaimTypesClaimTypesMeGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>
>;
export type GetParticipantClaimTypesClaimTypesMeGetQueryError = ErrorType<
  ErrorResponse | HTTPValidationError
>;

export function useGetParticipantClaimTypesClaimTypesMeGet<
  TData = Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params: undefined | GetParticipantClaimTypesClaimTypesMeGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>,
          TError,
          Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetParticipantClaimTypesClaimTypesMeGet<
  TData = Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetParticipantClaimTypesClaimTypesMeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>,
          TError,
          Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetParticipantClaimTypesClaimTypesMeGet<
  TData = Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetParticipantClaimTypesClaimTypesMeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Participant Claim Types
 */

export function useGetParticipantClaimTypesClaimTypesMeGet<
  TData = Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetParticipantClaimTypesClaimTypesMeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantClaimTypesClaimTypesMeGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetParticipantClaimTypesClaimTypesMeGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
